'use client';

import {
    ConsumerSubscriptionPlan,
    useConsumerSubscriptionPlan,
} from '@udemy-v2/subscription-graphql';

export interface NonCatalogPPPricing {
    nonCatalogPersonalPlan: ConsumerSubscriptionPlan | undefined;
    isAvailable: boolean;
    isLoading: boolean;
    isError: boolean;
    error?: Error;
}

interface UseNonCatalogPPPricingOptions {
    enabled?: boolean;
}

/**
 * Hook to fetch Personal Plan pricing without course catalog filtering.
 *
 * This hook queries for consumer subscription plans independently of the current course,
 * enabling us to show PP pricing for courses that are NOT in the PP catalog but ARE
 * eligible for the non-catalog offer.
 */
export function useNonCatalogPPPricing({
    enabled = true,
}: UseNonCatalogPPPricingOptions = {}): NonCatalogPPPricing {
    const consumerPlanContext = useConsumerSubscriptionPlan();
    const isLoading =
        enabled && consumerPlanContext && 'isLoading' in consumerPlanContext
            ? consumerPlanContext.isLoading
            : false;
    const nonCatalogPersonalPlan =
        enabled && consumerPlanContext && 'id' in consumerPlanContext
            ? (consumerPlanContext as ConsumerSubscriptionPlan)
            : undefined;

    return {
        nonCatalogPersonalPlan,
        isAvailable: !!nonCatalogPersonalPlan,
        isLoading,
        isError: false,
        error: undefined,
    };
}
